import AntDatePicker from "antd/lib/date-picker";
import clsx from "clsx";
import dateFnsGenerateConfig from "rc-picker/lib/generate/dateFns";

const Picker = AntDatePicker.generatePicker<Date>(dateFnsGenerateConfig);

export type DatePickerProps = React.ComponentProps<typeof Picker>;
export type WeekPickerProps = React.ComponentProps<typeof Picker.WeekPicker>;
export type MonthPickerProps = React.ComponentProps<typeof Picker.MonthPicker>;
export type YearPickerProps = React.ComponentProps<typeof Picker.YearPicker>;
export type RangePickerProps = React.ComponentProps<typeof Picker.RangePicker>;
export type TimePickerProps = React.ComponentProps<typeof Picker.TimePicker>;
export type QuarterPickerProps = React.ComponentProps<typeof Picker.QuarterPicker>;

const DatePickerBase = (props: DatePickerProps) => {
    const cellRender: DatePickerProps["cellRender"] = (current, info) => {
        if (info.type !== "date") {
            return info.originNode;
        }
        if (typeof current === "number" || typeof current === "string") {
            return <div className="ant-picker-cell-inner">{current}</div>;
        }
        return (
            <div className={clsx("ant-picker-cell-inner rounded-ant! before:rounded-ant!")}>{current.getDate()}</div>
        );
    };

    return <Picker cellRender={cellRender} {...props} />;
};

export const DatePicker = Object.assign(DatePickerBase, {
    WeekPicker: Picker.WeekPicker,
    MonthPicker: Picker.MonthPicker,
    YearPicker: Picker.YearPicker,
    RangePicker: Picker.RangePicker,
    TimePicker: Picker.TimePicker,
    QuarterPicker: Picker.QuarterPicker,
});
